import { DocumentNode, gql } from "@apollo/client";

class TestCardService {
  public static getTestsDataForHomePage = (): DocumentNode => gql`
    query GetTestsDataForHomePage {
      getTestsDataForHomePage {
        testCards {
          uid
          orderUidPublic
          testType
          status
          nextStatus
          managedBy
          drawCoordinator
          sampleCollectionDate
          isProReach
          sampleType
          sampleReceivedDate
          PTPOption
          viewStatus
          organType
          resultExpectedByDate
          createdAt
          resultReleasedAt
          cancelledAt
          latestResultDocumentUid
          trackingNumber
          reportGender
          caPnsSupplemental
          resultCode
          fetalSex
          clinic {
            limsId
          }
          isComboOrder
          isNevaEnabled
          isOrderInSignedOrdersTable
          simpleOrderWorkflowState
          isSignateraSubsequent
          isEmpowerStatPanelIncluded
          isLatestReleasedResultStat
          isStatResultAlreadyViewed
          isTfMrdActive
          tfMrdOrderingOption
          isReflexed
          isPatientResultReleaseDelayed
          patientResultAvailableAt
          # POC: Rules-based card fields
          title
          description
          statusText
          bottomLine
          primaryAction
          i18nKeys {
            title
            statusText
            description
            secondaryStatusText
            primaryAction
            nextStatus
            bottomLine
            params {
              date
              estimatedResultsDate
              sampleCollectionDate
              sampleReceivedDate
              resultsDelayedUntilDate
              resultExpectedByDate
            }
          }
          clinicalInfo {
            __typename
            ... on SignateraClinicalInfo {
              cancerType
              dateOfSurgery
            }
            ... on AlteraClinicalInfo {
              cancerType
              dateOfSurgery
            }
            ... on LatitudeClinicalInfo {
              cancerType
              dateOfSurgery
            }
          }
        }
        secondaryCards {
          type
          limsClinicId
        }
        isUserHasArchivedTests
      }
    }
  `;

  public static getTestCards = (): DocumentNode => gql`
    query GetTestCards($includeCompleted: Boolean) {
      getTestCards(includeCompleted: $includeCompleted) {
        uid
        orderUidPublic
        testType
        status
        nextStatus
        managedBy
        drawCoordinator
        sampleCollectionDate
        isProReach
        sampleType
        sampleReceivedDate
        PTPOption
        viewStatus
        organType
        resultExpectedByDate
        createdAt
        resultReleasedAt
        latestResultDocumentUid
        trackingNumber
        reportGender
        caPnsSupplemental
        resultCode
        fetalSex
        clinic {
          limsId
        }
        isComboOrder
        isNevaEnabled
        isOrderInSignedOrdersTable
        simpleOrderWorkflowState
        isSignateraSubsequent
        isEmpowerStatPanelIncluded
        isLatestReleasedResultStat
        isStatResultAlreadyViewed
        isTfMrdActive
        tfMrdOrderingOption
        isReflexed
        isPatientResultReleaseDelayed
        patientResultAvailableAt
        # POC: Rules-based card fields
        title
        description
        statusText
        bottomLine
        primaryAction
        i18nKeys {
          title
          statusText
          description
          secondaryStatusText
          primaryAction
          nextStatus
          bottomLine
          params {
            date
            estimatedResultsDate
            sampleCollectionDate
            sampleReceivedDate
            resultsDelayedUntilDate
            resultExpectedByDate
          }
        }
        clinicalInfo {
          __typename
          ... on SignateraClinicalInfo {
            cancerType
            dateOfSurgery
          }
          ... on AlteraClinicalInfo {
            cancerType
            dateOfSurgery
          }
          ... on LatitudeClinicalInfo {
            cancerType
            dateOfSurgery
          }
        }
      }
    }
  `;

  public static getEmpowerRiskAlertInfo = (): DocumentNode => gql`
    query {
      getEmpowerRiskAlertInfo {
        isEligible
        clinicLimsId
      }
    }
  `;

  public static getTestCardDetails = (): DocumentNode => gql`
    query GetTestCardDetails($orderUidPublic: String!, $testUid: String!) {
      getTestCardDetails(orderUidPublic: $orderUidPublic, testUid: $testUid) {
        uid
        businessUnit
        jobTypesConcatenated
        orderUidPublic
        testType
        status
        nextStatus
        managedBy
        drawCoordinator
        sampleCollectionDate
        isProReach
        sampleType
        sampleReceivedDate
        PTPOption
        viewStatus
        organType
        resultExpectedByDate
        createdAt
        resultReleasedAt
        cancelledAt
        latestResultDocumentUid
        trackingNumber
        kitShippedDate
        reportGender
        caPnsSupplemental
        resultCode
        fetalSex
        historicalMtmValues {
          date
          mtm
          resultCode
        }
        currentMtmValue
        mtmDelta
        physician {
          displayName
          firstName
          lastName
        }
        clinic {
          limsId
          name
        }
        limsId
        limsIds
        drawRequest {
          uid
          jobStart
          jobEnd
          jobStatus
          jobTypes
          note
          shippingAddress {
            city
            street
            state
            zipCode
          }
          start1
          start2
          start3
          end1
          end2
          end3
          jobTimezone
        }
        isComboOrder
        isNevaEnabled
        isPippaEnabled
        isOrderInSignedOrdersTable
        simpleOrderWorkflowState
        isSignateraSubsequent
        isOncologyOrder
        isEmpowerStatPanelIncluded
        isLatestReleasedResultStat
        isStatResultAlreadyViewed
        isTfMrdActive
        tfMrdOrderingOption
        isReflexed
        primaryAction
        nativeTestType
        isPatientResultReleaseDelayed
        patientResultAvailableAt
        resultDocumentsInfo {
          documentUid
          documentReferenceId
        }
        nevaSessionToken
        i18nKeys {
          title
          description
          statusText
          secondaryStatusText
          primaryAction
          nextStatus
          bottomLine
          params {
            date
            estimatedResultsDate
            sampleCollectionDate
            sampleReceivedDate
            resultsDelayedUntilDate
            resultExpectedByDate
          }
        }
        clinicalInfo {
          __typename
          ... on SignateraClinicalInfo {
            cancerType
            dateOfSurgery
          }
          ... on AlteraClinicalInfo {
            cancerType
            dateOfSurgery
          }
          ... on LatitudeClinicalInfo {
            cancerType
            dateOfSurgery
          }
        }
        patient {
          firstName
        }
      }
    }
  `;
}

export default TestCardService;
